import React, { useState, useEffect, useContext, useRef } from "react";
import { store } from "../../context/store";
import { functions } from "../../constants/common-functions";
import { colorFunctions } from "../../constants/colors";
import { useHistory } from "react-router-dom";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { STRINGIFY } from "../../constants/general-constants";
import background from "../../../images/background.jpg";
import {JWT} from "../../constants/local-storage";



export default function InsightsDocumentGenerator() {
	
	const [instructions, setInstructions] = useState("Fan coil unit fourth floor");
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState("");
	const [pdfUrl, setPdfUrl] = useState(null);
	const [externalReferences, setExternalReferences] = useState([]);
	const [drawerCollapsed, setDrawerCollapsed] =
	    useState(false);
	
	const publishingStages = [
	    "Selecting relevant engineering knowledge...",
	    "Retrieving building information...",
	    "Analysing engineering documentation...",
	    "Building technical summaries...",
	    "Writing report...",
	    "Generating engineering diagrams...",
	    "Publishing PDF..."
	];

	const [publishingStage, setPublishingStage] = useState(0);
	
	
	useEffect(() =>
	{
	    if(!loading)
	    {
	        setPublishingStage(0);
	        return;
	    }

	    const timer =
	        setInterval(() =>
	        {
	            setPublishingStage(previous =>
	            {
	                if(previous >= publishingStages.length - 1)
	                {
	                    return previous;
	                }

	                return previous + 1;
	            });
	        },3000);

	    return () => clearInterval(timer);

	},[loading]);

  // ---------------- STYLES ----------------

  const thisContainer = {
   	display:"flex",
   	position:"fixed",
   	flexDirection:"column",
   	right:"0px",
   	bottom:"0px",
   	left:"20px",
   	top:"0px",
	  zIndex:"1",
	  background: 'white',
	  padding:'20px'
   };

	
	async function handleGenerate()
	{
	    if (!instructions.trim())
	    {
	        setMessage("Please enter some instructions.");
	        return;
	    }
		setPdfUrl(null);
	    setLoading(true);
	    setMessage("");

	    try
	    {
			const response =
			        await fetch(
			                "/resolutionsoftwareplatform/forager",
			                {
			                    method:"POST",
			                    headers:
			                    {
			                        "Content-Type":"application/json",
			                        Authorization:
			                                "Bearer " +
			                                localStorage.getItem(JWT)
			                    },
			                    body:JSON.stringify(
			                    {
			                        instructions:instructions
			                    })
			                });

			if(!response.ok)
			{
			    throw new Error(
			            "Generation failed");
			}

			const result =
			        await response.json();


			const binary =
			        atob(result.pdf);

			const length =
			        binary.length;

			const bytes =
			        new Uint8Array(length);

			for(let i = 0;i < length;i++)
			{
			    bytes[i] =
			            binary.charCodeAt(i);
			}

			const blob =
			        new Blob(
			                [bytes],
			                {
			                    type:"application/pdf"
			                });

			const url =
			        window.URL.createObjectURL(
			                blob);

			setPdfUrl(
			        url);

			const report =
			{
			    title:"OmniScan AI Report",
			    url:url,
			    type:"PDF",
			    category:"REPORT",
			    manufacturer:"OmniScan",
				verified:true
			};

			setExternalReferences(
			[
			    report,
			    ...(result.externalReferences || [])
			]);
	    }
	    catch(e)
	    {
	        console.error(e);

	        setMessage(
	                "Failed generating document.");
	    }

	    setLoading(false);
	}
	
	
	function handleReferenceClick(reference)
	{
	    switch(reference.type)
	    {
	        case "REPORT":

	            setPdfUrl(
	                    reference.url);

	            break;

	        case "PDF":

	            setPdfUrl(
	                    reference.url);

	            break;

	        default:

	            window.open(
	                    reference.url,
	                    "_blank");
	    }
	}


  // ---------------- RENDER ----------------

  return (
    <div style={thisContainer}>
	

        <Header showSurveySelector = {false} transitionHide={true}/>
        <LeftMenu />

		

		{
		!pdfUrl &&

			<div
			    style={{
			        width:"900px",
			        background:"white",
			        borderRadius:"10px",
			        padding:"30px",
			        boxShadow:"0 10px 40px rgba(0,0,0,.12)",
					marginTop:"30px",
					marginLeft:"30px"
			    }}
			>
		
	
			<h2
			    style={{
			        marginTop:0,
			        marginBottom:"20px"
			    }}
			>
			    AI Document Generator
			</h2>
	
			<div
			    style={{
			        color:"#666",
			        marginBottom:"20px"
			    }}
			>
			    Describe the document you would like OmniScanPro AI to generate.
			</div>
	
			<textarea
	
			    value={instructions}
	
			    onChange={
			        e => setInstructions(
			                e.target.value)
			    }
	
			    //placeholder="Example: Generate an operation and maintenance manual for all HVAC equipment including maintenance schedules, inspection procedures and recommendations."
	
			    style={{
			        width:"100%",
			        height:"250px",
			        resize:"vertical",
			        fontSize:"15px",
			        padding:"15px",
			        borderRadius:"8px",
			        border:"1px solid #d0d0d0",
			        outline:"none",
			        boxSizing:"border-box"
			    }}
				
			>
						
			</textarea>
	
			<div
			    style={{
			        marginTop:"20px",
			        display:"flex",
			        justifyContent:"space-between",
			        alignItems:"center"
			    }}
			>
	
			<div
			    style={{
			        color:"#666"
			    }}
			>
			    {message}
			</div>
	
			<button
	
			    disabled={loading}
	
			    onClick={handleGenerate}
	
			    style={{
			        background:"#111",
			        color:"white",
			        border:"none",
			        padding:"12px 30px",
			        borderRadius:"8px",
			        cursor:"pointer",
			        fontSize:"15px"
			    }}
			>
	
			{loading
			    ? "Generating..."
			    : "Generate Document"}
	
			</button>
	
			</div>
		
		</div>
		
		}
		
		{
		loading &&

		<div
		    style={{
		        position:"fixed",
		        top:0,
		        left:0,
		        right:0,
		        bottom:0,
		        background:"rgba(0,0,0,0.8)",
		        display:"flex",
		        justifyContent:"center",
		        alignItems:"center",
		        zIndex:99999
		    }}
		>

		    <div
		        style={{
		            background:"rgba(255,255,255,0.08)",
		            backdropFilter:"blur(12px)",
		            border:"1px solid rgba(255,255,255,0.15)",
		            borderRadius:"18px",
		            padding:"50px 80px",
		            textAlign:"center",
		            color:"white"
		        }}
		    >

		        <div
		            style={{
		                width:"70px",
		                height:"70px",
		                border:"6px solid rgba(255,255,255,0.25)",
		                borderTop:"6px solid white",
		                borderRadius:"50%",
		                margin:"0 auto 30px auto",
		                animation:"spin 1s linear infinite"
		            }}
		        />

		        <div
		            style={{
		                fontSize:"30px",
		                fontWeight:600,
		                marginBottom:"15px"
		            }}
		        >
		            Generating Document
		        </div>

		        <div
		            style={{
		                fontSize:"17px",
		                color:"#dddddd",
		                maxWidth:"500px"
		            }}
		        >
		            OmniScanPro AI is analysing your knowledge base,
		            generating engineering summaries and publishing
		            your document.
		        </div>

		    </div>

		</div>

		}
		{
		pdfUrl &&

		<div
		    style={{
		        marginLeft:"50px",
		        flex:1,
		        display:"flex",
		        flexDirection:"column"
		    }}
		>


		<iframe

		    src={pdfUrl}

		    style={{
		        width:"100%",
		        height:"100%",
		        border:"1px solid #dddddd",
		        background:"white",
		        boxShadow:"0 10px 30px rgba(0,0,0,.12)"
		    }}

		/>

		</div>
		}
		{
		pdfUrl &&
		externalReferences.length > 0 &&

		<div
		    style={{
		        position:"fixed",
		        top:"0px",
		        right:"0px",
		        bottom:"0px",
		        width:
		            drawerCollapsed
		                ? "50px"
		                : "390px",
		        background:
		            "linear-gradient(180deg,#2a2a2a 0%,#171717 45%,#101010 100%)",
		        borderLeft:"1px solid rgba(255,255,255,.08)",
		        boxShadow:"-10px 0 40px rgba(0,0,0,.45)",
		        color:"white",
		        display:"flex",
		        flexDirection:"column",
		        zIndex:10000,
		        transition:"width .25s ease"
		    }}
		>

		    <div
		        style={{
		            display:"flex",
		            justifyContent:"space-between",
		            alignItems:"center",
		            padding:"20px",
		            borderBottom:"1px solid rgba(255,255,255,.08)",
		            background:
		                "linear-gradient(180deg,#343434,#242424)"
		        }}
		    >

		        {
		        !drawerCollapsed &&

		        <div>

		            <div
		                style={{
		                    fontSize:"22px",
		                    fontWeight:600,
		                    marginBottom:"6px"
		                }}
		            >
		                Engineering Resources
		            </div>

		            <div
		                style={{
		                    fontSize:"13px",
		                    color:"#a8a8a8"
		                }}
		            >
		                Official manufacturer documentation
		            </div>

		        </div>
		        }

		        <div

		            onClick={() =>
		                setDrawerCollapsed(
		                    !drawerCollapsed)}

		            style={{
		                cursor:"pointer",
		                fontSize:"24px",
		                color:"white",
		                width:"24px",
		                textAlign:"center"
		            }}

		        >

		            <FontAwesomeIcon
		                icon={
		                    drawerCollapsed
		                        ? "angle-left"
		                        : "angle-right"
		                }
		            />

		        </div>

		    </div>

		    {
		    !drawerCollapsed &&

		    <div
		        style={{
		            flex:1,
		            overflowY:"auto",
		            padding:"18px"
		        }}
		    >

			{
			    externalReferences.map(
			        (reference,index) =>

			        <div

			            key={
			                reference.url ||
			                index
			            }

			            onClick={
			                () =>
			                    handleReferenceClick(
			                        reference)
			            }

			            style={{
			                display:"block",
			                marginBottom:"14px",
			                padding:"18px",
			                borderRadius:"10px",
			                background:
			                    "linear-gradient(180deg,#2f2f2f,#252525)",
			                border:
			                    "1px solid rgba(255,255,255,.06)",
			                color:"white",
			                transition:"all .18s ease",
			                cursor:"pointer"
			            }}

			            onMouseEnter={
			                event =>
			                {
			                    event.currentTarget.style.background =
			                        "linear-gradient(180deg,#3b3b3b,#2f2f2f)";

			                    event.currentTarget.style.transform =
			                        "translateX(-3px)";
			                }
			            }

			            onMouseLeave={
			                event =>
			                {
			                    event.currentTarget.style.background =
			                        "linear-gradient(180deg,#2f2f2f,#252525)";

			                    event.currentTarget.style.transform =
			                        "translateX(0px)";
			                }
			            }

			        >

			            <div
			                style={{
			                    display:"flex",
			                    alignItems:"center"
			                }}
			            >

			                <FontAwesomeIcon
			                    icon={
			                        reference.type === "WEB"
			                            ? "globe"
			                            : "file-pdf"
			                    }

			                    style={{
			                        color:
			                            reference.type === "WEB"
			                                ? "#4aa3ff"
			                                : "#d43d3d",
			                        fontSize:"18px",
			                        marginRight:"14px"
			                    }}
			                />

			                <div
			                    style={{
			                        flex:1
			                    }}
			                >

			                    <div
			                        style={{
			                            fontSize:"15px",
			                            fontWeight:600,
			                            lineHeight:1.35
			                        }}
			                    >
			                        {reference.title}
			                    </div>

			                    <div
			                        style={{
			                            marginTop:"8px",
			                            fontSize:"11px",
			                            color:"#8c8c8c",
			                            overflow:"hidden",
			                            textOverflow:"ellipsis",
			                            whiteSpace:"nowrap"
			                        }}
			                    >
			                        {reference.manufacturer}
			                    </div>

			                </div>

			                {
			                    !reference.verified &&

			                    <FontAwesomeIcon
			                        icon="triangle-exclamation"

			                        title={
			                            "AI suggested resource.\n\n" +
			                            "This document could not be independently verified.\n" +
			                            "It may have moved, require authentication, or no longer be available."
			                        }

			                        style={{
			                            color:"#f5c542",
			                            fontSize:"17px",
			                            marginLeft:"12px",
			                            flexShrink:0
			                        }}
			                    />
			                }

			            </div>

			        </div>

			    )
			}

		    </div>

		    }

		</div>

		}
    </div>

  );
}

